import React from 'react';
import McqQuiz from './McqQuiz';
import ModeEmpty from './ModeEmpty';

/*
 * McqMode — driven entirely by the session config (no in-mode topic picker).
 * MCQs are generated by the engine from the configured concepts. With no scope
 * it points to Session Settings.
 */
const McqMode = ({ config, onConfigure, ...shell }) => {
  const scope = config?.subjects || [];
  if (!scope.length) {
    return (
      <ModeEmpty
        title="No topics configured"
        body="Choose topics in Session Settings and MCQs will be generated for them from your Knowledge Hub."
        scene="quiz"
        eyebrow="Retrieval practice"
        onConfigure={onConfigure}
      />
    );
  }
  const topics = scope.map((s) => s.name);
  const conceptIds = scope.map((s) => s.id);
  return (
    <McqQuiz
      key={topics.join(',')}
      topics={topics}
      conceptIds={conceptIds}
      difficulty="Mixed"
      engineDifficulty={config?.options?.difficulty || null}
      sessionSize={config?.options?.sessionSize || 10}
      onBack={shell.onBack || onConfigure}
      {...shell}
    />
  );
};

export default McqMode;
